import { z } from "zod";

import { IS_PRODUCTION } from "@/config/env";

const paginationSchema = z.object({
  pagination: z.object({
    total: z.number(),
    perPage: z.number(),
    currentPage: z.number(),
    totalPages: z.number(),
    hasMorePagesBefore: z.boolean().optional(),
    hasMorePagesAfter: z.boolean().optional(),
  }),
});

const getResponseSchema = <T>(schema: z.ZodType<T>) => {
  return z.object({
    data: z
      .object({
        data: schema,
      })
      .required(),
  });
};

const getPaginatedResponseSchema = <T>(schema: z.ZodType<T>) => {
  return z.object({
    data: z
      .object({
        data: schema,
      })
      .and(paginationSchema),
  });
};

export const parsePaginatedResponse = <T>(
  response: unknown,
  schema: z.ZodType<T>,
) => {
  return getPaginatedResponseSchema(schema).parse(response, {
    reportInput: !IS_PRODUCTION,
  }).data;
};

export const parseResponseData = <T>(
  response: unknown,
  schema: z.ZodType<T>,
) => {
  return getResponseSchema(schema).parse(response, {
    reportInput: !IS_PRODUCTION,
  }).data.data;
};
